import React from "react";
import "../../assets/css/concept.css";

const ConceptArea = () => {
  return (
    <section className="concept-container">
      <div className="spacer-box--l" />
      <div className="concept-container--inner yu-gothic center-box center">
        <div className="inline-block left">
          <div className="concept-headline">芸術の価値を守る</div>
          <div className="spacer-box--m" />
          <div className="concept-text">
            ShinGanは芸術作品の価値を守る技術です。
          </div>
          <div className="spacer-box--s" />
          <div className="concept-text">
            しかし、守るのは作品だけではありません。
          </div>
          <div className="spacer-box--s" />
          <div className="concept-text">
            「贋作」という不安要素を取り払うことは、作家のモチベーションを保つことやコレクターの購入意欲を促進させることにも繋がります。
          </div>
          <div className="spacer-box--s" />
          <div className="concept-text">
            つまり、「作品」「作家」「購入者」と市場に関わるすべての人の助けとなります。
          </div>
          <div className="spacer-box--s" />
          <div className="concept-text">
            ShinGanで、芸術に関わるすべての人を応援しませんか？
          </div>
          <div className="concept-text"></div>
        </div>
      </div>
      <div className="spacer-box--l" />
    </section>
  );
};
export default ConceptArea;
